package org.vreo.devicehub.features.userAuthentication.data.dto

import kotlinx.serialization.Serializable

/**
 * User sing in request dto
 *
 * @param username user's username or email
 * @param password user's password
 */
@Serializable
data class UserSignInRequestDto(
    val username: String,
    val password: String
)